<template>
  <ExploreBody/>
</template>

<script>
// @ is an alias to /src
import ExploreBody from '@/components/ExploreBody.vue'

export default {
  name: 'ExploreView',
  components: {
    ExploreBody
  }
}
</script>
